import { ESTIMATED_TAX_FIELD_TYPE } from "constants/estimatedTaxSections";

export const getEstimatedTaxQuarter = (formData: any): number | undefined => {
  const sections = formData?.data?.data?.section_group?.[0]?.sections;
  const estimatedTaxField = sections
    ?.flatMap((section: any) => section?.section_fields ?? [])
    ?.find((field: any) => field?.type === ESTIMATED_TAX_FIELD_TYPE);

  return estimatedTaxField?.data?.current_quarter?.quarter;
};
